import {
	FontIconName,
	IconButton,
	IconButtonKind,
	IconButtonSize
} from "client/Components";
import { ReactElement } from "react";
import { useCommunicationActions } from "../useCommunicationActions";
import styles from "./CommunicationButtons.module.less";
import classNames from "classnames";

export type CommunicationButtonsVariant = "details" | "list-item";

export type CommunicationButtonsProps = {
	emailAddress: string | null;
	phoneNumber: string | null;
	variant: CommunicationButtonsVariant;
};

export const CommunicationButtons = (props: CommunicationButtonsProps): ReactElement => {
	const {
		emailAddress,
		phoneNumber,
		variant
	} = props;

	const {
		sendEmail,
		makePhoneCall,
		startTeamsChat,
		startTeamsVideoCall
	} = useCommunicationActions({
		emailAddress,
		phoneNumber
	});

	return (
		<div
			className={classNames(
				styles.root,
				{[styles.root_details]: variant === "details"}
			)}
		>
			{Boolean(sendEmail) && (
				<CommunicationButton
					onClick={sendEmail}
					icon="envelope"
					trackingId="send-email"
					variant={variant}
				/>
			)}
			{Boolean(makePhoneCall) && (
				<CommunicationButton
					icon="phone"
					trackingId="make-phone-call"
					onClick={makePhoneCall}
					variant={variant}
				/>
			)}
			{Boolean(startTeamsVideoCall) && (
				<CommunicationButton
					onClick={startTeamsVideoCall}
					icon="video"
					trackingId="make-video-chat"
					variant={variant}
				/>
			)}
			{Boolean(startTeamsChat) && (
				<CommunicationButton
					onClick={startTeamsChat}
					icon="comment"
					trackingId="make-chat"
					variant={variant}
				/>
			)}
		</div>
	);
};
CommunicationButtons.displayName = "CommunicationButtons";

type CommunicationButtonProps = {
	icon: FontIconName;
	onClick?(): void;
	trackingId: string;
	variant: CommunicationButtonsVariant;
};

export const CommunicationButton = (props: CommunicationButtonProps): ReactElement => {
	const {
		icon,
		onClick,
		trackingId,
		variant
	} = props;

	return (
		<IconButton
			onClick={onClick}
			icon={icon}
			trackingId={trackingId}
			kind={variantToButtonKind[variant]}
			size={variantToButtonSize[variant]}
			shape="round"
			bubbleClick={false}
		/>
	);
};
CommunicationButton.displayName = "CommunicationButton";

const variantToButtonKind: { [key in CommunicationButtonsVariant]: IconButtonKind; } = {
	"details": "secondary",
	"list-item": "transparent"
};

const variantToButtonSize: { [key in CommunicationButtonsVariant]: IconButtonSize; } = {
	"details": "large",
	"list-item": "normal"
};